import React, { useEffect, useState } from 'react';
import './CSS/Local.css';
import Price from './Price';
import Header from './Header'
import Footer from './Footer'
import axios from "axios"
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

const MultiStepForm = () => {
    const [step, setStep] = useState(1);
    let login = JSON.parse(localStorage.getItem("login")) || "";
    // const [toast, setToast] = useState(null);

    const showToast = (message, type = "success") => {
        if (type === "success") {
            toast.success(message);
        } else if (type === "error") {
            toast.error(message);
        } else {
            toast(message); // Default toast
        }
    };



    const [addressR, setAddress] = useState({
        address: '',
        street: '',
        pincode: '',
        state: '',
        country: ''
    })
    const [formData, setFormData] = useState({
        // Personal Details
        full_name: login.full_name,
        Students_id: login.emplyee_ID,
        phone: '',
        email: login.email,
        blood_group: '',
        dob: '',
        nationality: '',
        gender: '',
        age: '',
        standard: '',
        photo: '',
        school_name: '',
        father_name: '',
        father_occupation: '',
        mother_name: '',
        mother_occupation: '',
        mother_phone: '',
        father_phone: "",
        // center_name: "",
        residential_address: "",
        // Address Details
        // address: '',
        // street: '',
        // pincode: '',
        // state: '',
        // country: '',
        emregency_contact: "",
        // Program Details
        subject: '',
        class_level: 'Beginner',
        session: 'Daily',
        center_name: '',

        // Payment Option
        paymentOption: 'Razorpay',

        // Fee Structure
        pricing_plan: [],
        timing: [],
        feeType: ''
    });
    const [center, setCenter] = useState([]);
    const [class_level, setClass_level] = useState([]);
    const [selectedCenter, setSelectedCenter] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [price, setPrice] = useState()
    const [admission, setAddmission] = useState({})
    const [paymentData, setPaymentData] = useState([]);
    const [filteredTimings, setFilteredTimings] = useState([]);
    const [selectedTimings, setSelectedTimings] = useState({});
    const [selectedTiming, setSelectedTiming] = useState(null);
    const [couponcheck, setCouponCheck] = useState({
        coupon_code: "",
        person_name: login.full_name,
        person_id: login.emplyee_ID,
        pricing_plan: [],
        mobile: formData.phone
    })

    const navigate = useNavigate()

    const handleFileChange = (e) => {
        const file = e.target.files[0]; // Get the selected file
        setFormData({
            ...formData,
            photo: file // Store the file in the state (assuming center is your state object)
        });
    };
    const handlePlanSelect = (plan, price, coupon) => {
        setSelectedPlan(plan);
        setPrice(price)
        console.log(price)
        setFormData({
            ...formData,
            pricing_plan: plan
        });
        setCouponCheck({
            ...couponcheck,
            coupon_code: coupon,
            pricing_plan: plan
        })
        // Do something with the selected plan if needed
        console.log('Selected Plan in Parent:', plan);
    };

    const fetchDataAdmission = async () => {
        try {
            const response = await fetch(`https://100billionrealestate.com/admission/singlead/${login.emplyee_ID}`)
            const res = await response.json();
            console.log(res);
            setAddmission(res);
        } catch (error) {
            console.log(error);
        }
    }
    const fetchCenterList = async () => {
        try {
            const response = await fetch(`https://100billionrealestate.com/centerlist/admin1997`)
            const res = await response.json();
            console.log(res);
            setCenter(res);
        } catch (error) {
            console.log(error);
        }
    }

    const activeClass = center.filter(center_name => center_name.status === 'Active');

    const options2 = activeClass.map(language => ({
        value: language.center_name,
        label: language.center_name,
    }));

    const fetchClassLevelList = async () => {
        try {
            const response = await fetch(`https://100billionrealestate.com/classlevel/admin1997`)
            const res = await response.json();
            console.log(res);
            setClass_level(res);
        } catch (error) {
            console.log(error);
        }
    }

    const activeClass1 = class_level.filter(center_name => center_name.status === 'Active');

    const options3 = activeClass1.map(language => ({
        value: language.class_level,
        label: (`${language.class_level}`),
    }));


    const fetchClassTiming = async () => {
        try {
            const response = await fetch(`https://100billionrealestate.com/classschedule/getalldata`);
            const res = await response.json();
            // console.log("hi", res);
            const filteredData = res.filter((classData) => {
                const classLevels = JSON.parse(classData.class_level || "[]");
                const ageGroups = JSON.parse(classData.age_group || "[]");
                console.log(classLevels, ageGroups);
                return (
                    classData.class_name === formData.center_name &&
                    classLevels.includes(formData.class_level) &&
                    ageGroups.some((ageRange) => {
                        const [min, max] = ageRange.split(" - ").map(Number);
                        return +formData.age >= min && +formData.age <= max;
                    })
                );
            });
            console.log(filteredData)

            setFilteredTimings(filteredData);
        } catch (error) {
            console.error("Error fetching class timings:", error);
        }
    };




    const groupTimingsByDay = (timings) => {
        const grouped = {};
        timings.forEach((timing) => {
            const frequency = JSON.parse(timing.frequency);
            frequency.forEach((slot) => {
                if (!grouped[slot.day]) {
                    grouped[slot.day] = [];
                }
                grouped[slot.day].push({
                    ...slot,
                    center: timing.class_name,
                });
            });
        });
        return grouped;
    };

    const handleSlotSelection = (day, slot) => {
        const selectedSlot = {
            day: slot.day,
            startTime: slot.startTime,
            endTime: slot.endTime,
            center: slot.center,
        };

        // Update selected timings state for display
        setSelectedTimings((prev) => ({
            ...prev,
            [day]: selectedSlot, // Ensure only one slot per day
        }));

        // Update the formData with the selected timing
        setFormData((prevData) => {
            const updatedTimings = prevData.timing.filter((t) => t.day !== day); // Remove existing timing for the same day
            return {
                ...prevData,
                timing: [...updatedTimings, selectedSlot], // Add the new timing
            };
        });
    };


    useEffect(() => {
        if (formData.center_name && formData.class_level && formData.age) {
            fetchClassTiming();
        }
    }, [formData.center_name, formData.class_level, formData.age]);


    const renderTimings = () => {
        const groupedTimings = groupTimingsByDay(filteredTimings);

        return Object.entries(groupedTimings).map(([day, slots]) => (
            <div key={day} className="timing-day-container">
                <h4 className="timing-day-title">{day}</h4>
                <div className="day-slots-container">
                    {slots.map((slot, index) => (
                        <div key={index} className={`timing-card ${selectedTimings[day]?.startTime === slot.startTime ? 'selected' : ''}`}>
                            <input
                                type="radio"
                                id={`slot-${day}-${index}`}
                                name={`slot-${day}`}
                                value={`${slot.center}-${slot.day}-${slot.startTime}-${slot.endTime}`}
                                onChange={() => handleSlotSelection(day, slot)}
                                checked={
                                    selectedTimings[day] &&
                                    selectedTimings[day].center === slot.center &&
                                    selectedTimings[day].day === slot.day &&
                                    selectedTimings[day].startTime === slot.startTime &&
                                    selectedTimings[day].endTime === slot.endTime
                                }
                            />
                            <label htmlFor={`slot-${day}-${index}`} className="timing-card-label">
                                <div className="timing-card-content">
                                    <div className="timing-card-time">
                                        {slot.startTime} - {slot.endTime}
                                    </div>
                                    {/* <div className="timing-card-center">{slot.center}</div> */}
                                </div>
                            </label>
                        </div>
                    ))}
                </div>
            </div>
        ));
    };


    const validateStep1 = () => {
        const requiredFields = [
            
            'phone',
            
        ];

        for (let field of requiredFields) {
            if (!formData[field]) {
                // toast.error(`Please fill all fields`)
                showToast(`Please fill all  fields`, "error");
                return false;
            }
        }
        return true;
    };

    // const validateStep2 = () => {
    //     const requiredFields = [
    //         'address',
    //         'street',
    //         'pincode',
    //         'state',
    //         'country',

    //     ];

    //     for (let field of requiredFields) {
    //         if (!addressR[field]) {
    //             showToast(`Please fill all  fields`, "error");
    //             // toast.error(`Please fill all fields`)
    //             return false;
    //         }
    //     }
    //     return true;
    // };
    const validateStep3 = () => {
        const requiredFields = [
            'center_name',
        ];

        for (let field of requiredFields) {
            if (!formData[field]) {
                // toast.error(`Please fill all fields`)
                showToast(`Please fill all  fields`);
                return false;
            }
        }
        return true;
    };

    const validateStep4 = () => {
        if (formData && formData.pricing_plan.length === 0) {
            // alert('Please select a pricing plan.');
            // toast.error(`Please select a pricing plan`)
            showToast(`Please select a pricing plan`, "error");
            return false;
        }

        return true;
    }

    const nextStep = () => {
        if (step === 1 && !validateStep1()) {
            return;
        }
        // if (step === 2 && !validateStep2()) {
        //     return;
        // }
        if (step === 3 && !validateStep3()) {
            return;
        }


        setStep(step + 1);
    };

    const prevStep = () => setStep(step - 1);

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0"); // Ensure two-digit month
        const day = String(today.getDate()).padStart(2, "0"); // Ensure two-digit day
        return `${year}-${month}-${day}`;
    };

    const handleInputChange = (event) => {
        if (event.target.name === "dob" && event.target.value > getCurrentDate()) {
            showToast(`Invalid DOB`, "error");
            return; // Prevent updating state
        }
        setFormData({
            ...formData,
            [event.target.name]: event.target.value
        });
        if (event.target.name === 'center_name') {
            const selected = center.find(c => c.center_name === event.target.value);
            setSelectedCenter(selected); // Update selected center details
        }
        if (event.target.name === "emregency_contact") {
            // Allow only numbers and restrict to 12 characters
            const numericValue = event.target.value.replace(/\D/g, ""); // Remove non-numeric characters
            setFormData({ ...formData, [event.target.name]: numericValue.slice(0, 12) });
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setAddress({
            ...addressR,
            [name]: value
        });

        const newAddress = {
            ...addressR,
            [name]: value
        };

        const residentialAddress = [
            newAddress.address,
            newAddress.street,
            newAddress.pincode,
            newAddress.state,
            newAddress.country
        ].filter(Boolean).join(', ');

        setFormData({
            ...formData,
            residential_address: residentialAddress
        });
    };



    console.log(formData)
    console.log(addressR)
    console.log(formData.pricing_plan.duration)
    const sendAddmissionForm = async () => {
        if (!validateStep4()) {
            showToast(`Please select a pricing plan`, "error");
        }

        const formDataToSubmit = new FormData();

        Object.keys(formData).forEach(key => {
            if (key === 'pricing_plan' || key === "timing") {
                // Special handling for cast_crew to ensure each entry is correctly formatted with images

                formDataToSubmit.append(key, JSON.stringify(formData[key]));

            } else if (key === 'photo') {
                formDataToSubmit.append(key, formData[key]); // Append file directly
            } else {
                formDataToSubmit.append(key, formData[key]);
            }
        });
        try {
            const response = await fetch(`https://100billionrealestate.com/admission`, {
                method: "POST",
                // headers: {
                //     "Content-Type": "application/json"
                // },
                body: (formDataToSubmit)
            })
            if (response.ok) {
                let res = await response.json();
                await handleClick()
            }
        } catch (error) {
            console.log(error)
        }
    }

    const loadScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false)
            }
            document.body.appendChild(script);
        })
    };

    console.log(selectedTiming);

    const handleCouponPostC = async () => {
        try {
            const response = await fetch(`https://100billionrealestate.com/coupon/apply`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(couponcheck)
            })
            if (response.ok) {
                let res = await response.json();
                showToast(`${res.message}`, "error");
                console.log(res);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const convertTo12HourFormat = (time) => {
        let [hours, minutes] = time.split(":").map(Number);
        let ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12; // Convert 0 to 12 for 12AM
        return `${hours}:${String(minutes).padStart(2, "0")} ${ampm}`;
    };
    

    const handleClick = async () => {
        try {
            let orderId = "11" + Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));
            await handleCouponPostC();
            // Load the Razorpay SDK
            let res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

            if (!res) {
                alert("Razorpay SDK Failed to load. Are you online?");
                return;
            }

            // Define payment details
            let paymentDetails = {
                transaction_id: orderId,
                pricing: formData.pricing_plan,
                duration: formData.pricing_plan.duration,
                user_id: login.emplyee_ID,
                user_phone: login.full_name,
                student: formData,
                amount: price * 100,
                currency: "INR",
                payment_mode: "online",
            };

            // Create order options
            let options = {
                key: "rzp_test_zEWr4dOpfx4w2F",
                currency: paymentDetails.currency,
                amount: paymentDetails.amount,
                name: "Demo",
                description: "Test Transaction",
                handler: async function (response) {

                    if (response.razorpay_payment_id) {
                        // Payment was successful
                        paymentDetails.razorpay_payment_id = response.razorpay_payment_id;
                        paymentDetails.status = 'Paid';
                        let result = await axios.post(`https://100billionrealestate.com/feespay`, paymentDetails);

                        if (!result.data.isError) {
                            // Redirect to the success page
                            //   checkPaymentStatus();

                            window.location.href = `/success`; // Replace "/success-page" with the URL of your success page
                        } else {
                            alert("Server error. Are You Online");

                        }
                    } else {
                        // Handle payment failure or cancellation
                        paymentDetails.status = 'Failed';
                        await axios.post(`https://100billionrealestate.com/feespay`, paymentDetails);
                        window.location.href = "/"; // Redirect to an error page
                    }
                },
                prefill: {
                    email: "pankajsbisht143@gmail.com",
                    contact: "9021733853"
                },
                notes: {
                    address: "Razorpay Corporate Office"
                },
                theme: {
                    color: "#1f5215"
                }
            };

            // Initialize Razorpay payment object and open checkout
            let paymentObject = new window.Razorpay(options);
            paymentObject.on('payment.failed', function (response) {

                paymentDetails.status = 'Failed';
                axios.post(`https://100billionrealestate.com/feespay`, paymentDetails)
                    .then(() => {
                        window.location.href = "/"; // Redirect to an error page
                    })
                    .catch(error => {

                        window.location.href = "/"; // Redirect to an error page
                    });
            });

            paymentObject.open();

        } catch (error) {
            console.log(error);
        }
    };

    const fetchPaymentData = async () => {
        try {
            const response = await fetch(`https://100billionrealestate.com/feespay/${login.emplyee_ID}`)
            const res = await response.json();
            console.log(res.data);
            setPaymentData(res.data);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchCenterList();
        fetchClassLevelList();
    }, [])

    useEffect(() => {
        fetchDataAdmission();
        fetchPaymentData();
        fetchClassTiming();
    }, [])


    const renderStepContent = () => {
        switch (step) {
            case 1:
                return (
                    <div className="form-step">
                        <h2>Subscribe a Plan</h2>
                        <div className="input-groupOms">
                            <label>Full Name</label>
                            <i className="fas fa-user input-icon"></i>
                            <input type="text" name="full_name" value={formData.full_name} placeholder="Full Name" onChange={handleInputChange} />
                        </div>
                        <div className="input-groupOms">
                            <label>Phone Number</label>
                            <i className="fas fa-phone input-icon"></i>
                            <input type="text" name="phone" value={formData.phone} placeholder="Number" onChange={handleInputChange} />
                        </div>
                        
                        <div className="input-groupOms">
                            <label>Email</label>
                            <i className="fas fa-envelope input-icon"></i>
                            <input type="email" name="email" value={formData.email} placeholder="Email" onChange={handleInputChange} />
                        </div>
                        <div className="input-groupOms">
                            <label>Date of Birth</label>
                            <i className="fas fa-calendar input-icon"></i>
                            <input type="date" name="dob" value={formData.dob} placeholder="Date of Birth" onChange={handleInputChange} />
                        </div>
                       

                        

                    </div>
                );
            case 2:
                return (
                    <div className="form-step">
                        <h2>Address Details</h2>
                        <div className="input-groupOms">
                            <label>Address</label>
                            <i className="fas fa-home input-icon"></i>
                            <input type="text" name="address" value={addressR.address} placeholder="Address" onChange={handleChange} />
                        </div>
                        <div className="input-groupOms">
                            <label>Street Name</label>
                            <i className="fas fa-street-view input-icon"></i>
                            <input type="text" name="street" value={addressR.street} placeholder="Street Name" onChange={handleChange} />
                        </div>
                        <div className="input-groupOms">
                            <label>Pincode</label>
                            <i className="fas fa-map-pin input-icon"></i>
                            <input type="text" name="pincode" value={addressR.pincode} placeholder="Pincode" onChange={handleChange} />
                        </div>
                        <div className="input-groupOms">
                            <label>State</label>
                            <i className="fas fa-flag input-icon"></i>
                            <input type="text" name="state" value={addressR.state} placeholder="State" onChange={handleChange} />
                        </div>
                        <div className="input-groupOms">
                            <label>Country</label>
                            <i className="fas fa-globe input-icon"></i>
                            <input type="text" name="country" value={addressR.country} placeholder="Country" onChange={handleChange} />
                        </div>
                    </div>
                );
            case 3:
                return (
                    <>
                        <div className="form-step1">
                            <h2>Program Details</h2>
                            <div className="input-groupOms">
                                <label>Services</label>
                                <i className="fas fa-map-marker-alt input-icon"></i>
                                <select name="center_name" value={formData.center_name} onChange={handleInputChange}>
                                    <option value="">Select Service</option>
                                    {options2.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* <div className="input-groupOms">
                                <label>Level</label>
                                <i className="fas fa-graduation-cap input-icon"></i>
                                
                                <select name="class_level" value={formData.class_level} onChange={handleInputChange}>
                                    <option value="">Select Level</option>
                                    {options3.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div> */}

                        </div>
                        {/* update in new file */}
                        {selectedCenter && (
                            <>
                                <div className="center-details">
                                    <h2 className='planstep3Oms'>{selectedCenter.center_name}</h2>
                                    <p><strong>Description:</strong> {selectedCenter.location}</p>
                                    <div className="divider"></div> {/* Divider between location and timing */}

                                    <p><strong>Support Hours:</strong></p>
                                    {console.log(selectedCenter.open_hours)}
                                    {JSON.parse(selectedCenter.open_hours) && JSON.parse(selectedCenter.open_hours).map((timeSlot, index) => (
                                        <div key={index} className="timing">
                                            <strong>{timeSlot.day}:</strong>
                                            <span>{convertTo12HourFormat(timeSlot.startTime)} - {convertTo12HourFormat(timeSlot.endTime)}</span>
                                        </div>
                                    ))}
                                </div>
                                <div className='timingstudenttake'>
                                    {renderTimings()}
                                </div>
                                <Price  center={formData.center_name} onPlanSelect={handlePlanSelect} />
                            </>
                        )}





                    </>
                );
           
            default:
                return null;
        }
    };

    console.log(admission.status === "Pending" && paymentData.length > 0);
    if (admission.status === "Pending" && paymentData.length > 0) {
        return <>
            {/* <Header /> */}
            <div className="multi-step-form">
                <p className='multiformptagstep3' >

                    Your Admission is under process, you can check its status by clicking on below button
                </p>

                <div class="arrow-container">
                    <div class="arrow"></div>
                </div>
                <div  style={{textAlign:"center"}} >
                    <button className='multibuttonstep3oms' mt={"40px"} bg="#1e90ff" color="white" _hover={{ bg: "#1e90ff", color: "white" }} onClick={() => navigate("/profile")}>Check Status</button>
                </div>
            </div>
            <Footer />
        </>
    } else if (admission.status === "Pending" && paymentData.length === 0) {
        return (
            <>
                <Header />
                <div className="multi-step-form">
                    <p className='multuipaystep3oms' >
                        Your Payment is Pending, Select Payment Plan from the below option.

                    </p>
                    <Price age={admission.age} level={admission.class_level} center={admission.center_name} onPlanSelect={handlePlanSelect} />
                    <div style={{textAlign:"center"}}>
                        <button className='paynowmultistep3oms' onClick={handleClick}>PAY NOW

                        </button>
                    </div>
                </div>
                <Footer />
            </>
        )
    }
    return (
        <>
            {/* <Header /> */}
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <div className="multi-step-form">
                <div className="step-indicator">
                    <div className={`step ${step === 1 ? 'active' : step > 1 ? 'completed' : ''}`}>1</div>
                    <div className={`step ${step === 2 ? 'active' : step > 2 ? 'completed' : ''}`}>2</div>
                    <div className={`step ${step === 3 ? 'active' : step > 3 ? 'completed' : ''}`}>3</div>
                    <div className={`step ${step === 4 ? 'active' : ''}`}>4</div>
                </div>
                {renderStepContent()}
                <div className="button-group">
                    {step > 1 && <button type="button" className="btn-prev" onClick={prevStep}>Back</button>}
                    {step < 4 ? (
                        <button type="button" className="btn-next" onClick={nextStep}>Next</button>
                    ) : (
                        <button type="submit" className="btn-submit" onClick={sendAddmissionForm}>Submit</button>
                    )}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default MultiStepForm;